export default __webpack_public_path__ + "static/media/vr_dev_img.e293b4c2.svg";